import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import confetti from 'canvas-confetti';
import { CheckCircle, Home, FileText, ArrowRight, Share2 } from 'lucide-react';
import Header from '../../../components/Header';

export default function LeaseSuccess() {
  const navigate = useNavigate();
  const { appId } = useParams();

  useEffect(() => {
    // 🎊 Explosion de confettis au chargement
    const duration = 3 * 1000;
    const animationEnd = Date.now() + duration;
    const defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 0 };

    const randomInRange = (min: number, max: number) => Math.random() * (max - min) + min;

    const interval: any = setInterval(function() {
      const timeLeft = animationEnd - Date.now();
      if (timeLeft <= 0) return clearInterval(interval);

      const particleCount = 50 * (timeLeft / duration);
      confetti({ ...defaults, particleCount, origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 } });
      confetti({ ...defaults, particleCount, origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 } });
    }, 250);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="min-h-screen bg-white font-sans selection:bg-teal-500">
      <Header />
      
      <main className="max-w-4xl mx-auto px-6 pt-32 pb-20 text-center">
        <div className="inline-flex items-center justify-center w-24 h-24 bg-teal-100 text-teal-600 rounded-[2.5rem] mb-8 animate-bounce">
          <CheckCircle size={48} strokeWidth={2.5} />
        </div>

        <h1 className="text-5xl md:text-6xl font-black text-slate-900 tracking-tighter mb-6">
          C'est officiel, <br />
          <span className="text-teal-500">le bail est scellé !</span>
        </h1>
        
        <p className="text-xl text-slate-500 font-medium max-w-2xl mx-auto mb-12">
          Félicitations ! Les deux parties ont signé le document. Forfeo Habitat vient de sécuriser votre transaction immobilière au Québec.
        </p>

        <div className="grid md:grid-cols-2 gap-4 max-w-2xl mx-auto">
          <button 
            onClick={() => navigate(`/habitat/lease/${appId}`)}
            className="flex items-center justify-center gap-3 bg-slate-900 text-white p-6 rounded-3xl font-black uppercase tracking-widest hover:bg-teal-600 transition-all shadow-xl hover:scale-[1.02]"
          >
            <FileText size={20} /> Voir le bail final
          </button>

          <button 
            onClick={() => navigate('/habitat')}
            className="flex items-center justify-center gap-3 bg-slate-100 text-slate-900 p-6 rounded-3xl font-black uppercase tracking-widest hover:bg-slate-200 transition-all hover:scale-[1.02]"
          >
            <Home size={20} /> Retour à l'accueil
          </button>
        </div>

        <div className="mt-20 p-8 bg-slate-50 rounded-[3rem] border border-slate-100">
          <h3 className="text-sm font-black uppercase tracking-widest text-slate-400 mb-6">Prochaines étapes recommandées</h3>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="space-y-2">
              <div className="w-10 h-10 bg-white rounded-xl shadow-sm flex items-center justify-center mx-auto text-teal-500 font-black">1</div>
              <p className="text-xs font-bold text-slate-700">Changement d'adresse (Hydro-Québec)</p>
            </div>
            <div className="space-y-2">
              <div className="w-10 h-10 bg-white rounded-xl shadow-sm flex items-center justify-center mx-auto text-teal-500 font-black">2</div>
              <p className="text-xs font-bold text-slate-700">Assurance habitation</p>
            </div>
            <div className="space-y-2">
              <div className="w-10 h-10 bg-white rounded-xl shadow-sm flex items-center justify-center mx-auto text-teal-500 font-black">3</div>
              <p className="text-xs font-bold text-slate-700">Prise de possession des clés</p>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
